<template>

  <div class="container">

    <div id="loader">
      <div class="text-center" v-if='loading'>
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>

    </div>

    <div id="content">

      <div class="row mb-2">
        <div class="col-md-9">
          <h4 class="h4">
            Comunidad K-9
          </h4>
        </div>
        <div class="col-md-3">
          <b-button style="float: right;" variant="primary">
            <b-link to="/" class="home-button">
              Directorio
            </b-link>
          </b-button>
        </div>
        <div class="col-md-12">
          <p style="margin-top: 20px; text-align: justify">
            En la Corporación K-9 queremos apoyar a todos los negocios que han emprendido a raíz de la pandemia por COVID 19.
            Permítanos conocerlos y apoyarlos!
            Queremos apoyar iniciativas de negocio que beneficien directamente a nuestros colaboradores y sus familias y crear un directorio que será promovido a lo interno de la Corporación para incentivar las ventas entre todos los que integramos esta gran familia.
            Permítanos conocerlos y apoyarlos!
          </p>
        </div>
      </div>
      <hr/>

      <b-form @submit.prevent="doSubmit()" novalidate>

        <div class="row">

          <!-- Company -->
          <div class="col-md-6 col-sm-12">
            <b-form-group
              class="form-label"
              label="Empresa para la que labora">
              <b-form-select
                v-model="form.database"
                @input="cleanData()"
                :options="companies">
              </b-form-select>
            </b-form-group>
          </div>

          <!-- Gov Id-->
          <div class="col-md-6 col-sm-12">
            <b-form-group
              class="form-label"
              label="Número de cédula">
              <b-input-group
                id="kgroup"
                class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input
                  v-model="form.govId"
                  @keyup.enter.native="doSearchEmployee()"
                  @input="cleanData()"
                  placeholder="Número de cédula"
                  required
                >
                </b-form-input>

                <div class="text-center" v-if="loadingEmployee">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                </div>

                <b-button
                  class="is-primary"
                  type="button"
                  :disabled="!isValidId()"
                  role="button"
                  @click="doSearchEmployee()"
                  variant="primary">
                  Buscar
                </b-button>
              </b-input-group>
            </b-form-group>
          </div>
          <!-- Gov Id-->

        </div>

        <div class="row mt-2">

          <!-- Name -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Nombre completo">
              <b-form-input
                v-model="form.name"
                min="0"
                required
                placeholder="- -"
                disabled
              >
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Name -->

          <!-- Code -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Número de gafete">
              <b-form-input
                v-model="form.code"
                placeholder="- -"
                disabled>
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Code -->

          <!-- Department -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Bravo">
              <b-form-input
                v-model="form.departmentId"
                placeholder="- -"
                required
                disabled>
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Department -->
        </div>

        <hr/>

        <div id="donation" class="mb-5" v-if="loadedEmployee">
          <p>Datos</p>

          <div class="row mt-2">

            <!-- Business Name -->
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Nombre del emprendimiento/negocio">
                <b-form-input
                  v-model="form.businessName"
                  :state="isValidName()"
                  required
                >
                </b-form-input>
                <b-form-invalid-feedback id="business-name-feedback">
                  Indique el nombre del emprendimiento o negocio
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Business Name -->

          </div>

          <div class="row mt-2">

            <!-- Business Detail -->
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Descripción del emprendimiento/negocio">
                <b-form-textarea
                  v-model="form.businessDetail"
                  :state="isValidDetail()"
                  required
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="business-detail-feedback">
                  Indique cuáles son los servicios o productos que ofrece
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Business Detail -->

          </div>

          <div class="row mt-2">

            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Forma de entrega">

                <b-form-checkbox
                  v-for="obj in form.deliveryOptions"
                  :key="obj.name"
                  v-model="obj.value">
                  {{ obj.name }}
                </b-form-checkbox>

                <b-form-invalid-feedback id="business-location-feedback">
                  Indique se tiene servicio a domicilio, o entregas por uber, glovo, etc
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

          </div>

          <div class="row mt-2">

            <!-- Social Media -->
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Redes sociales">

                <b-form-checkbox
                  v-for="obj in form.socialMediaOptions"
                  :key="obj.source"
                  v-model="obj.value"
                >
                  {{ obj.source }}
                  <b-form-input
                    v-if="obj.value"
                    v-model="obj.detail">
                  </b-form-input>
                  <p v-if="obj.value"
                    style="font-size: 80%; margin-top: 0.5em;">
                    Indique como sale en la red social
                  </p>
                </b-form-checkbox>

                <b-form-invalid-feedback id="business-location-feedback">
                  Indique se tiene servicio a domicilio, o entregas por uber, glovo, etc
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Social Media -->

          </div>

          <div class="row mt-2">

            <!-- Coverage area -->
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Área de cobertura">
                <b-form-input
                  v-model="form.areaCoverage"
                  :state="isValidCoverage()"
                  required
                >
                </b-form-input>
                <b-form-invalid-feedback id="business-area-feedback">
                  Indique el área de cobertura del emprendimiento o negocio (por ejemplo GAM, solo Heredia)
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Business Name -->

          </div>

          <h5 style="text-align: left">Ubicación</h5>
          <p>
            Indique la dirección exacta del negocio o emprendimiento. Seleccione, provincia, cantón y distrito.
          </p>

          <hr/>
          <div class="row">

            <!-- Province -->
            <div class="col-md-4 col-sm-12">
              <b-form-group
                class="form-label"
                label="Provincia">

                <b-form-select
                  v-model="form.provinceId"
                  @change="loadCantons()"
                  :options="provinces">
                </b-form-select>
              </b-form-group>

            </div>
            <!-- Province -->

            <!-- Canton -->
            <div class="col-md-4 col-sm-12">

              <b-form-group
                class="form-label"
                label="Cantón">

                <b-input-group
                  id="cgroup"
                  class="mb-2 mr-sm-2 mb-sm-0">

                  <b-form-select
                    v-model="form.cantonId"
                    @change="loadDistricts()"
                    :disabled="cantons.length == 0"
                    :options="cantons">
                  </b-form-select>

                  <div class="text-center" v-if="loadingCantons">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                  </div>

                </b-input-group>

              </b-form-group>

            </div>
            <!-- Canton -->

            <!-- District -->
            <div class="col-md-4 col-sm-12">

              <b-form-group
                class="form-label"
                label="Distrito">

                <b-input-group
                  id="dgroup"
                  class="mb-2 mr-sm-2 mb-sm-0">

                  <b-form-select
                    v-model="form.districtId"
                    :disabled="districts.length == 0"
                    :options="districts">
                  </b-form-select>

                  <div class="text-center" v-if="loadingDistricts">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                  </div>

                </b-input-group>

              </b-form-group>

            </div>
            <!-- District -->

            <!-- Detail -->
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Detalle dirección">
                <b-form-textarea
                  v-model="form.addressDetail"
                  min="0"
                  :state="isValidLocation()"
                  required
                  placeholder="Detalle dirección">
                </b-form-textarea>
                <b-form-invalid-feedback id="business-location-feedback">
                  Indique otras señas.
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Name -->

          </div>

          <div class="row mt-2 mb-2">
            <div class="col-md-12 col-sm-12">
              <p>Busque la ubicación del negocio en el mapa</p>
            </div>

            <!-- Location -->
            <div class="col-md-12 col-sm-12">
              <div class="column no-padding">
                <gmap-map
                  @click="mark"
                  :center="center"
                  :zoom="13"
                  style="width:100%;  height: 400px;">
                  <gmap-marker
                    :position="form.marker"
                    @click="center=marker">
                  </gmap-marker>
                </gmap-map>
              </div>
            </div>

          </div>

          <div class="row mt-4">

            <!-- Categories -->
            <div class="col-md-6 col-sm-12">
              <b-form-group
                class="form-label"
                label="Seleccione una categoría">
                <b-form-select
                  v-model="form.category"
                  :state="isValidCategory()"
                  :options="categories">
                </b-form-select>
                <b-form-invalid-feedback id="business-category-feedback">
                  Indique la categoría asociada al emprendimiento/negocio
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Categories -->

            <!-- Phone -->
            <div class="col-md-6 col-sm-12">
              <b-form-group
                class="form-label"
                label="Teléfono/contacto">
                <b-form-input
                  v-model="form.businessPhone"
                  :state="isValidPhone()"
                  :maxlength="9"
                  v-mask="'####-####'"
                  required
                >
                </b-form-input>
                <b-form-invalid-feedback id="business-phone-feedback">
                  Indique el número de teléfono del negocio o emprendimiento
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <!-- Phone -->

          </div>

          <!-- Image upload -->
          <div class="row mt-2">
            <div class="col-md-12 col-sm-12">
              <b-form-group
                class="form-label"
                label="Subir foto / publicidad">
                <b-form-file
                  @change="previewImage"
                  :state="(form.images.length > 0) ? true : false"
                  accept="image/*"
                  required
                  multiple="multiple"
                  type="file"
                >
                </b-form-file>
                <b-form-invalid-feedback id="business-file-feedback">
                  Adjunte las fotografías o publicidad que tenga sobre el negocio o emprendimiento (Puede subir una o más imágenes)
                </b-form-invalid-feedback>
              </b-form-group>

              <div v-if="uploadingImg">
                <p>Subiendo imágen: {{uploadValue.toFixed()+"%"}}
                  <progress id="progress" :value="uploadValue" max="100" ></progress>  </p>
              </div>
            </div>
          </div>
          <!-- Image upload -->

          <!-- Image Display -->
          <div class="row" v-if="form.images.length > 0">
            <div class="col-md-3"
              v-for="image in form.images"
              :key="image">
              <img class="preview" :src="image">
            </div>
          </div>
        </div>
        <!-- Images -->

        <div class="row" v-if="!isValidForm() && loadedEmployee">
          <div class="col-md-12">
            <p style="font-size: 80%; margin-top: 0.5em;color: #dc3545;">
              Por favor revise que todos los campos estén completos para finalizar el registro
            </p>
          </div>
        </div>

        <!-- Image Display -->
        <div class="row mb-2">
          <div class="col">
            <b-button
              id="btn-submit"
              :disabled="!isValidForm() || submitting"
              class="is-primary submit-button"
              type="submit"
              variant="primary">
              Enviar datos
            </b-button>
          </div>
        </div>
        <!-- Image Display -->

        <div class="row mb-2">
          <div class="col">
            <div class="text-center" v-if="submitting">
              <div class="spinner-border" role="status">
                <span class="sr-only">Enviando datos...</span>
              </div>
            </div>
          </div>
        </div>

      </b-form>

      <b-modal
        ref="alert-modal"
        :width="640"
        scroll="keep"
        @ok="resetForm()"
        @cancel="resetForm()">
        <div class="container">
          <div class="content">
            <h3 class="is-5 spaced">
              {{ alert.title }}
            </h3>
            <p class="detail">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </b-modal>

      <b-modal
        ref="msg-modal"
        :width="640"
        scroll="keep"
        ok-only ok-variant="secondary"
        ok-title="Aceptar">
        <div class="container">
          <div class="content">
            <h3 class="is-5 spaced">
              {{ alert.title }}
            </h3>
            <p class="detail">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </b-modal>

    </div>

  </div>

</template>

<script>
import axios from 'axios';
import numeral from 'numeral';
import firebase from 'firebase';

export default {
  name: 'Form',
  components: {},
  data() {
    return {
      uploadValue: 0,
      center: {
        lat: 9.979304,
        lng: -84.0881,
      },
      selectedCompany: 'knueveint',
      companies: [
        {
          value: 'knueveint',
          text: 'K-9 Internacional'
        },
        {
          value: 'cops',
          text: 'Cops K-9'
        },
        {
          value: 'inspectors',
          text: 'Klean 9'
        },
        {
          value: 'abc',
          text: 'ABC Seguridad'
        },
      ],
      categories: [
        'Accesorios para vehículos',
        'Animales y Mascotas',
        'Autos, Motos y Otros',
        'Celulares y Teléfonos',
        'Computación',
        'Cámaras y fotografías',
        'Electrodomésticos',
        'Agro',
        'Arte y Antiguedades',
        'Bebés',
        'Coleccionables y Hobbies',
        'Consolas y Videojuegos',
        'Deportes y Fitness',
        'Electrónica, Audio y Video',
        'Herramientas y  Construcción',
        'Industria y Oficinas',
        'Instrumentos Musicales',
        'Juegos y Jueguetes',
        'Música y Películas',
        'Ropa y Accesorios',
        'Servicios',
        'Hogar, Muebles y Jardín',
        'Inmuebles',
        'Joyas y Relojes',
        'Libros, Revistas y Comics',
        'Otras categorías',
        'Salud y Belleza',
      ],
      requiredFields: {
        code: '',
        name: '',
        category: '',
        areaCoverage: '',
        departmentId: '',
        database: '',
        provinceId: '',
        cantonId: '',
        districtId: '',
        addressDetail: '',
        businessPhone: '',
        businessName: '',
        businessDetail: '',
      },
      loadingEmployee: false,
      loadedEmployee: false,
      loading: false,
      submitting: false,
      uploadingImg: false,
      selected: [],
      provinces: [
        { value: 1, text: 'San José' },
        { value: 2, text: 'Alajuela' },
        { value: 3, text: 'Cartago' },
        { value: 4, text: 'Heredia' },
        { value: 5, text: 'Guanacaste' },
        { value: 6, text: 'Puntarenas' },
        { value: 7, text: 'Limón' },
      ],
      cantons: [],
      districts: [],
      loadingCantons: false,
      loadingDistricts: false,
      form : {
        socialMediaOptions: [
          {
            value: false,
            source: 'Facebook',
            detail: '',
          },
          {
            value: false,
            source: 'Twitter',
            detail: '',
          },
          {
            value: false,
            source: 'Instagram',
            detail: '',
          },
          {
            value: false,
            source: 'Web',
            detail: '',
          },
        ],
        deliveryOptions: [
          {
            name: 'Uber Eats',
            value: false,
          },
          {
            name: 'Glovo',
            value: false,
          },
          {
            name: 'Rappi',
            value: false,
          },
          {
            name: 'Correos de Costa Rica',
            value: false,
          },
          {
            name: 'A domicilio',
            value: false,
          },
          {
            name: 'Para recoger',
            value: false,
          }
        ],
        images: [],
        userId: null,
        category: null,
        govId: null,
        departmentId: null,
        database: 'knueveint',
        businessName: null,
        businessDetail: null,
        businessLocation: null,
        businessPhone: null,
        areaCoverage: null,
        provinceId: null,
        cantonId: null,
        districtId: null,
        addressDetail: '',
        marker: {
          lat: 9.979304,
          lng: -84.0881,
        },
      },
      alert: {
        title: null,
        detail: null,
      },
    }
  },
  methods: {
    isValidName() {
      let name = this.form.businessName
      return ((name) ? (name != '') : false);
    },
    isValidCoverage() {
      let area = this.form.areaCoverage
      return ((area) ? (area != '') : false);
    },
    isValidDetail() {
      let detail = this.form.businessDetail
      return ((detail) ? (detail != '') : false);
    },
    isValidLocation() {
      let val = this.form.addressDetail
      return ((val) ? (val != '') : false);
    },
    isValidCategory() {
      let val = this.form.category
      return ((val) ? (val != '') : false);
    },
    isValidPhone() {
      let phone = this.form.businessPhone
      if (phone != '') {
        var re  = /^\d{4}-\d{4}$/
        var res = re.test(phone)
        return res;
      }
      return false;
    },
    formatNumber(value) {
      return numeral(value).format('0,0');
    },
    validateRequiredParams() {
      for (let key in this.requiredFields) {
        var kval = this.form[key]
        if (!kval) {
          return false;
        } else {
          if (kval === '- -') {
            return false;
          }
        }
      }
      return true
    },
    resetForm() {
      this.form =  {
        userId: null,
        govId: null,
        database: 'knueveint',
        code: '',
        category: '',
        name: '',
        departmentId: '',
        businessPhone: '',
        businessName: '',
        businessDetail: '',
        businessDelivery: '',
        provinceId: null,
        cantonId: null,
        districtId: null,
        addressDetail: '',
        images: [],
        marker: {
          lat: 9.979304,
          lng: -84.0881,
        },
        socialMediaOptions: [
          {
            value: false,
            source: 'Facebook',
            detail: '',
          },
          {
            value: false,
            source: 'Twitter',
            detail: '',
          },
          {
            value: false,
            source: 'Instagram',
            detail: '',
          },
          {
            value: false,
            source: 'Web',
            detail: '',
          },
        ],
        deliveryOptions: [
          {
            name: 'Uber Eats',
            value: false,
          },
          {
            name: 'Glovo',
            value: false,
          },
          {
            name: 'Rappi',
            value: false,
          },
          {
            name: 'Correos de Costa Rica',
            value: false,
          },
          {
            name: 'A domicilio',
            value: false,
          },
          {
            name: 'Para recoger',
            value: false,
          }
        ],
      }
      this.$refs['alert-modal'].hide()
    },
    isValidForm() {
      return this.loadedEmployee && this.validateRequiredParams() && this.isValidPhone() && this.isValidCategory()
    },
    isValidId() {
      return this.form.govId != '';
    },
    capitalizeName(name) {
      let nameParts = name.split(' ');
      var cleanName = '';
      for (var i=0; i < nameParts.length; i++) {
        let nm = nameParts[i].toLowerCase()
        nm = nm.charAt(0).toUpperCase() + nm.slice(1);
        if (i != 0) {
          cleanName += ' '
        }
        cleanName += nm
      }
      return cleanName
    },
    handleEmployee(employee) {
      this.form.userId = employee.id
      this.form.name = employee.name
      this.form.code = employee.code
      this.form.departmentId = employee.departmentId
      this.loadedEmployee = true;
    },
    handleError() {
      this.cleanData()
      this.alert = {
        title: 'Empleado no encontrado',
        detail: 'El empleado no ha sido encontrado en nuestra base de datos',
      }
      this.$refs['msg-modal'].show()
    },
    doSearchEmployee() {
      this.loadingEmployee = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/invoice/user`, {
        params: {
          govId: this.form.govId,
          database: this.form.database,
        }
      }).then(response => {
        if (response) {
          this.handleEmployee(response.data)
        } else {
          this.handleError()
        }
      }).catch(() => {
        this.handleError()
      }).finally(() => {
        this.loadingEmployee = false
      })
    },
    cleanData() {
      this.form.userId = null
      this.form.name = null
      this.form.code = null
      this.form.departmentId = null
      this.loadedEmployee = false;
    },
    doSubmit() {
      this.submitting= true;
      axios.post(`${process.env.VUE_APP_SERVER_ENDPOINT}/community/register`, this.form)
        .then(() => {
          this.resetForm()
          this.alert = {
            title: '¡Muchas gracias por la información!',
            detail: 'Mantengase pendiente para la publicidad que haremos de su emprendimiento.',
          }
          this.loadedEmployee = false;
        })
        .catch(err => {
          console.log(err)
          if (err.response) {
            this.alert = {
              title: 'Atención',
              detail: err.response.data,
            }
            this.loadedEmployee = false;
          }
        })
        .finally(() => {
          this.$refs['alert-modal'].show()
          this.submitting = false
        })
    },
    mark(event) {
      const lat = event.latLng.lat()
      const lng = event.latLng.lng()
      this.form.marker = {
        lat: lat,
        lng: lng,
      }
    },
    setSelectedValue(value) {
      if (this.form.amount == value) {
        this.form.amount = null;
      } else {
        this.form.amount =  value;
      }
    },
    previewImage(event) {
      const imageFiles = event.target.files
      this.uploadingImg = true
      for (const img of imageFiles) {
        const storageRef=firebase.storage().ref(`${img.name}`).put(img);
        storageRef.on(`state_changed`,snapshot=>{
          this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        }, error => {
          console.log(error.message)
        },
          ()=>{this.uploadValue=100;
            storageRef.snapshot.ref.getDownloadURL().then((url)=>{
              this.form.images.push(url)
              this.uploadingImg = false
            });
          }
        );
      }
    },
    loadCantons() {
      const province = this.form.provinceId;
      if (province) {
        this.loadingCantons = true;
        axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/utils/cantons/${province}`)
          .then(response => {
            let results = response.data
            if (results) {
              this.cantons = results;
            }
          })
          .catch(() => {
            this.form.name = '- -'
          })
          .finally(() => {
            this.loadingCantons = false
          })
      }
    },
    loadDistricts() {
      const province = this.form.provinceId
      const canton = this.form.cantonId;
      if (province && canton) {
        this.loadingDistricts = true;
        axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/utils/districts/${province}/${canton}`)
          .then(response => {
            let results = response.data
            if (results) {
              this.districts = results;
            }
          })
          .catch(() => {
            this.form.name = '- -'
          })
          .finally(() => {
            this.loadingDistricts = false
          })
      }
    },

  },

}
</script>

<style scoped>
.container {
  margin-bottom: 20px;
  height: 100%;
}
#btn-submit {
  float: right;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.upload-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  margin-top: 2.5em;
  width: 600px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.preview  {
  height: 200px;
  width: 100%;
  object-fit: contain;
}

a {
  color: #42b983;
}

.money-button {
  background-color: light-grey;
  width: 100%;
}

.money-button:hover, .money-button:focus,
.money-button-selected:hover, .money-button-selected:focus,
.money-button-selected {
  width: 100%;
  background-color: green !important;
  border-color: green !important;
}

/* Landscape phones and down */
@media (max-width: 575.98px) {

  .button-container {
    margin-top: 15px;
  }

  .money-button, .money-button-selected, .submit-button {
    width: 100%;
  }

  .submit-button {
    margin-bottom: 10px;
  }

}

.home-button {
  color: white;
  font-size: 20px;
  padding: 20px;
}
</style>
